"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
const classnames_1 = __importDefault(require("classnames"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const Icon = (props) => {
    const { src } = props;
    const [svgHasStyle, setSvgHasStyle] = react_1.useState(false);
    const primitiveProps = helpers_1.usePrimitiveProps(helpers_1.without(props, ['ref']));
    if (typeof src === 'string') {
        primitiveProps.className = classnames_1.default(primitiveProps.className.replace('j-icon-wrap', ''), { 'svg-icon': true, 'has-style': svgHasStyle });
        // Why?: This will automatically inline the svg into the DOM
        // Which will make it accessible for color change via CSS.
        if (src.endsWith('.svg')) {
            return (
            /* innerRef on SVG is not a element. */
            react_1.default.createElement("div", { className: "j-icon-wrap", ref: props.forwardedRef },
                react_1.default.createElement(react_inlinesvg_1.default, Object.assign({ preProcessor: (code) => {
                        setSvgHasStyle(code.includes('<style'));
                        return code;
                    }, src: src }, primitiveProps))));
        }
        return react_1.default.createElement("img", Object.assign({ alt: "icon", src: src }, primitiveProps));
    }
    const IconComponent = src;
    return (
    /* react-icons components dont have refs so we wrap around div. */
    react_1.default.createElement("div", Object.assign({ className: "j-icon-wrap", ref: props.forwardedRef }, helpers_1.without(primitiveProps, ['ref', 'src'])),
        react_1.default.createElement(IconComponent, { src: undefined })));
};
exports.default = withJourney_1.default('j-icon', Icon);
